export const zh = {
    "OK": "确认",
    "Cancel": "取消",
    "Keyword": "关键字",
    "Search": "查询",
    "Reset": "重置",
    "Name": "名称",
    "LocalizedName": "本地化名称",
    "Code": "代码",
    "Description": "描述",
    "Add": "添加",
    "Edit": "编辑",
    "Action": "操作"
}